import React from "react";
import ReactHtmlParser from 'react-html-parser';

const SearchItemsList = ({ searchItems, cursor, selectItem }) => {
    return (
        <ul className="auto-complete-list">
            <span class="search-recommendation">{episerver_SearchSuggestions}</span>
            {searchItems.map((item, idx) => (
                <li
                    className={
                        cursor === idx ? "active list-group-item" : "list-group-item"
                    }
                    key={idx}
                    onClick={(e) => selectItem(e, item)}
                >
                    {ReactHtmlParser(String(item).replace(
                        new RegExp(document.querySelector(".icon-search input").value, "gi"),
                        "<strong>$&</strong>"))}
                </li>
            ))}
        </ul>
    );
};

export default SearchItemsList;